import {
  AppLayout,
  Button,
  Checkbox,
  Container,
  Form,
  FormField,
  Header,
  Input,
  SpaceBetween,
  TextContent
} from '@cloudscape-design/components';
import { UserContext } from '../context/authContext';
import { useContext, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { TopNavigationBar } from './Components/TopNavigation';

export const LoginPage = () => {
  const { getSignIn, token } = useContext(UserContext);
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [remember, setRemember] = useState<boolean>(false);
  console.log('user token', token);

  return (
    <>
      {!token ? (
        <div style={{ position: 'fixed', top: 0, width: '100%' }}>
          <TopNavigationBar />

          <AppLayout
            headerSelector=".b"
            toolsHide
            navigationHide
            content={
              <Container>
                <form onSubmit={(e) => e.preventDefault()}>
                  <Form
                    actions={
                      <SpaceBetween direction="horizontal" size="xs">
                        <Button formAction="none" variant="link">
                          Cancel
                        </Button>
                        <Button
                          variant="primary"
                          onClick={() => getSignIn(email, password, remember)}
                        >
                          Login
                        </Button>
                      </SpaceBetween>
                    }
                  >
                    <Container header={<Header variant="h2">Login</Header>}>
                      <SpaceBetween direction="vertical" size="l">
                        <FormField label="Email">
                          <Input
                            value={email}
                            type="text"
                            onChange={({ detail }) => setEmail(detail.value)}
                          />
                        </FormField>
                        <FormField label="Password">
                          <Input
                            value={password}
                            type="password"
                            onChange={({ detail }) => setPassword(detail.value)}
                          />
                        </FormField>
                        <Checkbox
                          onChange={({ detail }) => setRemember(detail.checked)}
                          checked={remember}
                        >
                          Remember Me
                        </Checkbox>
                      </SpaceBetween>
                    </Container>
                  </Form>
                </form>
              </Container>
            }
          />
        </div>
      ) : (
        <Navigate to="/app/landing" />
      )}
    </>
  );
};
